<calcite-tile-group scale="l" alignment="center">
  <calcite-tile
    icon="presentation"
    heading="Download Presentation"
    (click)="sessionPage.downloadPresentation()"
  />
  <calcite-tile
    icon="file-excel"
    heading="Download Excel"
    onclick="alert('Excel download not yet implemented')"
  />
</calcite-tile-group>
